import React, { useState } from "react";
import "./Slider.css";

interface SliderComponentProps {
  label: string;
  minRange: number;
  maxRange: number;
  inputValue?: number;
  onChange: (label: string, value: number) => void;
}

const SliderComponent: React.FC<SliderComponentProps> = ({
  label,
  minRange,
  maxRange,
  inputValue,
  onChange,
}: SliderComponentProps) => {
  const [value, setValue] = useState<number>(
    inputValue ? inputValue : minRange
  );
  // const percentRef = useRef<HTMLSpanElement | null>(null);
  // const sliderRef = useRef<HTMLInputElement | null>(null);

  // useEffect(() => {
  //   if (percentRef.current && sliderRef.current) {
  //     const sliderWidth = sliderRef.current.clientWidth;
  //     const valuePercentage = (value - minRange) / (maxRange - minRange);
  //     const xPosition = valuePercentage * (sliderWidth - 10) + 4;

  //     percentRef.current.textContent = `$${value}`;
  //     percentRef.current.style.left = `${Math.floor(
  //       xPosition - percentRef.current.offsetWidth / 2
  //     )}px`;
  //   }

  //   if (sliderRef.current) {
  //     sliderRef.current.value = String(value);
  //   }
  // }, [value, minRange, maxRange]);

  const handleSliderInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    setValue(newValue);
    onChange(label.toLowerCase(), newValue);
  };

  return (
    <div className="price-bar d-flex my-2 ms-md-2">
      <div className="price-box">
        {/* <span className="price-value">{label}</span> */}
        <span id="price-value">{minRange}%</span>
        <div className="slide" style={{ position: "relative" }}>
          <input
            // ref={sliderRef}
            className="price-slider"
            type="range"
            min={minRange}
            max={maxRange}
            step="1"
            value={value}
            onInput={handleSliderInput}
          />
        </div>
        <span>{maxRange}%</span>
      </div>

      <span
        // ref={percentRef}
        className="value-box ms-2"
        // style={{
        //   position: "absolute",
        //   top: "-32px",
        // }}
      >
        <span>{value}</span>
      </span>
    </div>
  );
};

export default SliderComponent;
